import { render, staticRenderFns } from "./Decline.vue?vue&type=template&id=c900617e"
import script from "./Decline.vue?vue&type=script&lang=js"
export * from "./Decline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports